export default __webpack_public_path__ + "static/03.05-46b63859704670d5d071823a4be44384.png";